import UtilObject from "@/utils/UtilObject";
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

import GrupoService from "./GrupoService";

export default {

    async getOneById(colaboradorID = ""){

        let colaborador;

        try{

            colaborador = await ERP.getOneById(Schema.COLABORADOR, colaboradorID);
            if(colaborador.status != 200){
                throw colaborador;
            }

            console.log(colaborador);

        }catch(e){

            console.log(e);
            return colaborador;

        }

        return colaborador;

    },

    async getManyById(colaboradorIDs = []){

        let colaboradores;

        try{

            colaboradores = await ERP.getManyById(Schema.COLABORADOR, colaboradorIDs);
            if(colaboradores.status != 200){
                throw colaboradores;
            }

            console.log(colaboradores);

        }catch(e){

            console.log(e);
            return colaboradores;

        }

        return colaboradores;

    },

    async pegaColaboradorUsuario(colaboradorID = ""){

        let colaborador;
        let response = {
            url: "",
            status: 200,
            statusText: "",
            data: "",
        };

        try{

            colaborador = await this.getOneById(colaboradorID);
            if(colaborador.status != 200){
                throw colaborador;
            }

            if(!colaborador?.data?.user?.userId){
                throw colaborador;
            }

            response.url = colaborador?.url || "";
            response.data = colaborador?.data?.user?.userId || "";

        }catch(e){

            console.log(e);
            colaborador.status = 400;
            return colaborador;

        }

        console.log(response);

        return response;

    },

    async pegaColaboradoresUsuario(colaboradorIDs = []){

        let colaboradores;
        let response = {
            url: "",
            status: 200,
            statusText: "",
            data: [],
        };

        try{

            colaboradores = await this.getManyById(colaboradorIDs);
            if(colaboradores.status != 200){
                throw colaboradores;
            }

            let colaboradoresUsuarios = colaboradores.data.map((colaborador)=>{

                if(colaborador?.user?.userId){
                    return colaborador?.user?.userId
                }else{
                    throw colaborador;
                }

            });

            response.url = colaboradores.url || "";
            response.data = colaboradoresUsuarios || [];

        }catch(e){

            console.log(e);
            colaboradores.status = 400;
            return colaboradores;

        }

        console.log(response);

        return response;

    },


    async pegaColaboradorGrupo(colaboradorID = ""){

        let grupo;

        try{

            //==================================================================//
            //======================= Pega Colaborador =========================//
            //==================================================================//

            let colaborador = await this.getOneById(colaboradorID);
            if(colaborador.status != 200){
                throw colaborador;
            }

            let colaboradorGrupoNome = colaborador.data.grupo;
            if(!colaboradorGrupoNome){
                throw colaborador;
            }

            //==================================================================//
            //========================== Pega Grupo ============================//
            //==================================================================//

            grupo = await GrupoService.pegaGrupoPorNome(colaboradorGrupoNome)
            if(grupo.status != 200){
                throw grupo;
            }

        }catch(e){

            console.log(e);
            return grupo;

        }

        return grupo;

    },

}